import React, { FC, memo } from 'react';
import { IDResource } from 'types';
import styles from '../index.module.scss';

interface IhomeRoomListItemProps {
  idx: number;
  dndId: number;
  data: IDResource;
  anetapackHomeRoom?: IDResource[];
  removeResourceFromSchedule?: (id: number) => void;
}
const homeRoomListItem: FC<IhomeRoomListItemProps> = ({ data }) => {
  return (
    <div>
      <div
        style={{ background: '#F5FDFF', borderLeft: '2px solid #168abc' }}
        className={styles.dResouceItem}
      >
        <div
          style={{ background: '#F5FDFF' }}
          className={styles.backgroundHomeroom}
        >
          <span style={{ color: '#168abc' }} title={data.link}>
            {data.link}
          </span>
        </div>
      </div>
    </div>
  );
};

export default memo(homeRoomListItem);
